import styled from 'styled-components';

import { device } from 'common/constants/mediaQueries';

/**
 * The design's `.pair` — the canonical control for all six bilingual entities.
 *
 * Two equal columns, EN left and AR right, both fields starting at the top of
 * the row so their labels sit on one baseline. That last part is the whole
 * point: the forms previously stacked the two sides in Bootstrap `col-md-6`
 * cells of unequal content, or in separate rows entirely, so on Menu Details
 * the English and Arabic labels sat at different heights and the fields did
 * not line up.
 *
 * Collapses to one column at the same width the sidebar collapses at.
 */
export const Pair = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--s4);
  align-items: start;

  @media ${device.laptop} {
    grid-template-columns: 1fr;
  }
`;
